import axios from "axios";

// The ingress routes /api on the same host as the frontend; using the page origin
// avoids cross-origin cookie/CORS issues caused by ingress Origin rewriting.
const BASE = (typeof window !== "undefined" && window.location?.origin) || process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retry && !(orig.url || "").includes("/auth/")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

const asUTC = (d) => {
  if (!d) return null;
  let s = String(d);
  if (/^\d{4}-\d{2}-\d{2}T/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/.test(s)) s += "Z";
  return new Date(s);
};

export const fmtDate = (d) => {
  const dt = asUTC(d);
  return dt ? dt.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric" }) : "-";
};

export const fmtDT = (d) => {
  const dt = asUTC(d);
  return dt ? dt.toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true }) : "-";
};

export const fmtQty = (n) =>
  n === null || n === undefined ? "-" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 3 });

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const fileUrl = (p) => (!p ? "" : p.startsWith("data:") ? p : `${window.location.origin}${p}`);
